import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

import { registerImportSanitizer } from './registerImportSanitizer';

/** Always on in rich mode; see `registerImportSanitizer`. */
export const ImportSanitizerPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => registerImportSanitizer(editor), [editor]);

  return null;
};
